/**
 * 不同云域名映射，用于配置埋点区域
 */
const HOST_MAP = __LYSORA__
  ? __DEV__ || __TEST__
    ? new Map([
        /**
         * 白牌测试环境
         */
        [
          'lysoratech.rj.link',
          {
            href: 'https://lysoratech.rj.link/design/',
            region: 'ME'
          }
        ]
      ])
    : new Map([
        /**
         * 美国云
         */
        [
          'cloud-us.lysoratech.com',
          {
            href: 'https://cloud-us.lysoratech.com/design/',
            region: 'ME'
          }
        ]
      ])
  : new Map([
      /**
       * 国内测试环境
       */
      [
        'lysoratech.rj.link',
        {
          /**
           * 云地勘链接地址
           */
          href: 'https://lysoratech.rj.link//design/',
          /**
           * 区域
           */
          region: 'CN',
          /**
           * 神策埋点 URL
           */
          sensorsURL: 'https://lysoratech.rj.link/web.gif',
          /**
           * 神策埋点名称
           */
          sensorsName: 'dev-cloud',
          /**
           * 神策埋点 ID
           */
          sensorsID: 'sensorsDataAnalytic201505',
          /**
           * 神策数据采集是否可用
           */
          sensorsAvailable: true
        }
      ],
      /**
       * 海外测试环境
       */
      [
        'lysoratech.rj.link',
        {
          href: 'https://lysoratech.rj.link//design/',
          region: 'CN',
          sensorsURL: 'https://rycem-evt.lysoratech.com/web.gif',
          sensorsName: 'dev-macc_oversea',
          sensorsID: 'sensorsDataAnalytic201505',
          sensorsAvailable: true
        }
      ],

      /**
       * 国内云
       */
      [
        'cloud-us.lysoratech.com',
        {
          href: 'https://cloud-us.lysoratech.com/design/',
          region: 'CN',
          sensorsURL: 'https://lysoratech.rj.link/web.gif',
          sensorsName: 'cloud',
          sensorsID: 'sensorsDataAnalytic201505',
          sensorsAvailable: true
        }
      ],
      /**
       * 中亚云
       */
      [
        'cloud-a1.lysoratech.com',
        {
          href: 'https://cloud-a1.lysoratech.com/design/',
          region: 'RU'
        }
      ],
      /**
       * 亚洲云
       */
      [
        'cloud-as.lysoratech.com',
        {
          href: 'https://cloud-as.lysoratech.com/design/',
          region: 'AS',
          sensorsURL: 'https://rycem-evt.lysoratech.com/web.gif',
          sensorsName: 'macc_oversea',
          sensorsID: 'sensorsDataAnalytic201505',
          sensorsAvailable: true
        }
      ],
      /**
       * 欧洲云
       */
      [
        'cloud-eu.lysoratech.com',
        {
          href: 'https://cloud-eu.lysoratech.com/design/',
          region: 'EU'
        }
      ],
      /**
       * 拉美云
       */
      [
        'cloud-la.lysoratech.com',
        {
          href: 'https://cloud-la.lysoratech.com/design/',
          region: 'LA'
        }
      ],
      /**
       * 美国云
       */
      [
        'cloud-us.lysoratech.com',
        {
          href: 'https://cloud-us.lysoratech.com/design/',
          region: 'ME'
        }
      ],
      /**
       * 澳洲云
       */
      [
        'cloud-ap.lysoratech.com',
        {
          href: 'https://cloud-ap.lysoratech.com/design/',
          region: 'AU'
        }
      ],
      /**
       * 中东云
       */
      [
        'cloud-me.lysoratech.com',
        {
          href: 'https://cloud-me.lysoratech.com/design/',
          region: 'ME'
        }
      ]
    ]);

/**
 * 当前域名对应的事件追踪配置
 *
 * - 开发环境使用 lysoratech.rj.link 域名配置
 * - 生产环境使用当前域名配置
 */
export const CURRENT_HOST_EVENT_TRACKING_OPTIONS = __DEV__
  ? __LYSORA__
    ? HOST_MAP.get('lysoratech.rj.link')
    : __APP_BRAND__ === 'lysora'
    ? HOST_MAP.get('lysoratech.rj.link')
    : HOST_MAP.get('lysoratech.rj.link')
  : HOST_MAP.get(window.location.host);

/**
 * 当前域名神策埋点是否可用
 *
 * ⚠️ 神策数据采集在中国区和亚洲区可用，其他区域不可用。
 */
export const CURRENT_HOST_SENSORS_AVAILABLE = !!CURRENT_HOST_EVENT_TRACKING_OPTIONS?.sensorsAvailable;

/**
 * 当前云域名对应的区域
 * 如果没有匹配到，则默认为中国区
 * @type {String}
 */
export const CURRENT_HOST_REGION = CURRENT_HOST_EVENT_TRACKING_OPTIONS?.region || 'CN';
